var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-draggable-resizable",
    {
      attrs: {
        w: _vm.width,
        h: _vm.height,
        x: _vm.posX,
        y: _vm.posY,
        active: true,
        parent: true,
        resizable: true,
        "class-name-handle": "object-form-resizable-handle",
        "drag-handle": ".drag",
        "data-app": ""
      },
      on: { resizing: _vm.onResizing, dragstop: _vm.onDragStop }
    },
    [
      _c(
        "div",
        {
          ref: "changeLogForm",
          staticClass: "changeLogForm",
          style: { height: _vm.height + "px" }
        },
        [
          _c("form-header", {
            attrs: { title: _vm.pageTitle },
            on: { close: _vm.close }
          }),
          _vm._v(" "),
          _c("change-log-data-table", {
            staticClass: "overflow-y-auto",
            staticStyle: {
              overflow: "auto",
              height: "calc(100% - 74px)",
              margin: "20px"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4c83dbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4c83dbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/ChangeLogForm/ChangeLogForm.vue
// module id = null
// module chunks = 